import { computed, toValue, type MaybeRefOrGetter } from 'vue';

export function useEmbeddableMedia(embed: MaybeRefOrGetter<string | null | undefined>) {
  const isEmbed = computed(() => {
    const value = toValue(embed);

    return value != null && value !== '';
  });

  const isYoutube = computed(() => {
    if (!isEmbed.value) {
      return false;
    }

    const embedUrl = (toValue(embed) ?? '').trim();

    return embedUrl.includes('youtube.com') || embedUrl.includes('youtu.be');
  });

  return { isEmbed, isYoutube };
}
